import React, { useState, useRef } from 'react';
import { motion, PanInfo, useAnimation } from 'framer-motion';
import { ChevronRight, ChevronLeft, Timer, Flame } from 'lucide-react';
interface BonusOffer {
  id: number;
  title: string;
  description: string;
  discount: string;
  expiryHours: number;
  icon: string;
  code: string;
}
export function BonusOffers() {
  const [activeIndex, setActiveIndex] = useState(0);
  const constraintsRef = useRef<HTMLDivElement>(null);
  const controls = useAnimation();
  const bonusOffers: BonusOffer[] = [{
    id: 1,
    title: 'Flash Deal',
    description: 'Limited time offer',
    discount: '40% OFF',
    expiryHours: 4,
    icon: '⚡',
    code: 'FLASH40'
  }, {
    id: 2,
    title: "Today's Special",
    description: 'Exclusive to you',
    discount: 'BOGO',
    expiryHours: 12,
    icon: '🎁',
    code: 'BOGO2023'
  }, {
    id: 3,
    title: 'Weekend Bonus',
    description: 'For loyal customers',
    discount: '€15 OFF',
    expiryHours: 48,
    icon: '🔥',
    code: 'WEEKEND15'
  }, {
    id: 4,
    title: 'New User Special',
    description: 'First purchase deal',
    discount: '50% OFF',
    expiryHours: 24,
    icon: '🌟',
    code: 'WELCOME50'
  }];
  const handleDragEnd = (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => {
    const threshold = 100;
    if (info.offset.x < -threshold && activeIndex < bonusOffers.length - 1) {
      setActiveIndex(activeIndex + 1);
    } else if (info.offset.x > threshold && activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    } else {
      // Reset position if threshold not met
      controls.start({
        x: 0
      });
    }
  };
  const handleNext = () => {
    if (activeIndex < bonusOffers.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };
  const handlePrev = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };
  return <section className="mb-8" data-id="element-23">
      <div className="flex justify-between items-center mb-4" data-id="element-24">
        <div className="flex items-center" data-id="element-25">
          <h2 className="text-xl font-bold" data-id="element-26">Today's Bonus Offers</h2>
          <Flame className="ml-2 h-5 w-5 text-gray-500" data-id="element-27" />
        </div>
        <div className="flex space-x-2" data-id="element-28">
          <button onClick={handlePrev} disabled={activeIndex === 0} className={`p-1 rounded-full ${activeIndex === 0 ? 'text-gray-300' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-29">
            <ChevronLeft size={20} data-id="element-30" />
          </button>
          <button onClick={handleNext} disabled={activeIndex === bonusOffers.length - 1} className={`p-1 rounded-full ${activeIndex === bonusOffers.length - 1 ? 'text-gray-300' : 'text-gray-700 hover:bg-gray-100'}`} data-id="element-31">
            <ChevronRight size={20} data-id="element-32" />
          </button>
        </div>
      </div>
      <div className="relative overflow-hidden" ref={constraintsRef} data-id="element-33">
        <div className="flex" data-id="element-34">
          {bonusOffers.map((offer, index) => {
          const isActive = index === activeIndex;
          return <motion.div key={offer.id} className="w-full flex-shrink-0" animate={{
            x: `${-100 * activeIndex}%`,
            scale: isActive ? 1 : 0.9,
            opacity: isActive ? 1 : 0.5
          }} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.1} onDragEnd={handleDragEnd} style={{
            x: controls.x
          }} data-id="element-35">
                <div className="mx-2 rounded-xl shadow-lg overflow-hidden cursor-pointer bg-gray-900" data-id="element-36">
                  <div className="p-5 text-white" data-id="element-37">
                    <div className="flex justify-between items-start" data-id="element-38">
                      <div data-id="element-39">
                        <h3 className="text-xl font-bold" data-id="element-40">{offer.title}</h3>
                        <p className="text-sm opacity-90" data-id="element-41">
                          {offer.description}
                        </p>
                      </div>
                      <span className="text-3xl" data-id="element-42">{offer.icon}</span>
                    </div>
                    <div className="mt-4" data-id="element-43">
                      <div className="text-4xl font-bold mb-3" data-id="element-44">
                        {offer.discount}
                      </div>
                      <div className="flex justify-between items-center" data-id="element-45">
                        <div className="flex items-center bg-white/20 px-3 py-1 rounded-full" data-id="element-46">
                          <Timer className="h-4 w-4 mr-1" data-id="element-47" />
                          <span className="text-sm" data-id="element-48">
                            {offer.expiryHours}h left
                          </span>
                        </div>
                        <button className="bg-white text-black px-4 py-1 rounded-full font-medium text-sm hover:bg-white/90 transition" data-id="element-49">
                          Claim Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
        <div className="flex justify-center mt-3" data-id="element-50">
          {bonusOffers.map((_, index) => <button key={index} onClick={() => setActiveIndex(index)} className={`w-2 h-2 mx-1 rounded-full transition-all ${index === activeIndex ? 'bg-black w-4' : 'bg-gray-300'}`} data-id="element-51" />)}
        </div>
      </div>
    </section>;
}